
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_46136","data-name":"Group 46136","xmlns":"http://www.w3.org/2000/svg","width":"55","height":"55"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15530","data-name":"Rectangle 15530","width":"15","height":"15","transform":"translate(20 20)","fill":"#fff","stroke":"#707070","stroke-width":"1"}})])]),_c('rect',{attrs:{"id":"Rectangle_15467","data-name":"Rectangle 15467","width":"55","height":"55","rx":"17","fill":"#efe8fe"}}),_c('g',{attrs:{"id":"Mask_Group_22197","data-name":"Mask Group 22197","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_29899","data-name":"Path 29899","d":"M4.1 5.156a1.71 1.71 0 012.535-1.5l10.525 5.79a1.709 1.709 0 010 3L6.64 18.233a1.71 1.71 0 01-2.536-1.5z","transform":"translate(16.423 16.555)","fill":"#9a69fa","fill-rule":"evenodd"}})])])
          )
        }
      }
    